import React, { useState } from 'react';
import { motion } from 'framer-motion';
import FamilyOverviewBg from '../images/ui/dark-blue-bg.jpg';
import VideoBg from '../video/blue-bg.mp4';
import Overview from './FamilyOverview/Overview';
import Features from './FamilyOverview/Features';
import FeatureMatrix from './FamilyOverview/FeatureMatrix';
import TechnicalDetails from './FamilyOverview/TechnicalDetails';
import MagentaLine from './elements/MagentaLine';

export default function FamilyOverview() {
  const [content, setContent] = useState('overview');
  return (
    <div id="family-overview-wrapper">
      <img src={FamilyOverviewBg} className="full-bg" />
      <motion.video
        src={VideoBg}
        className="full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="70px" left="40px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '24px',
              top: '42px',
              left: '40px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            A state-of-the-art rechargeable solution{' '}
            <strong>full of options</strong>
          </motion.div>
        </div>
      </header>

      <nav>
        <div
          onClick={() => {
            setContent('overview');
          }}
          className={content === 'overview' ? 'active' : ''}
        >
          Overview
        </div>
        <div
          onClick={() => {
            setContent('features');
          }}
          className={content === 'features' ? 'active' : ''}
        >
          Features
        </div>
        <div
          onClick={() => {
            setContent('feature-matrix');
          }}
          className={content === 'feature-matrix' ? 'active' : ''}
        >
          Feature Matrix
        </div>
        <div
          onClick={() => {
            setContent('technical-details');
          }}
          className={content === 'technical-details' ? 'active' : ''}
        >
          Technical Details
        </div>
      </nav>
      <div id="content">
        {content === 'overview' && <Overview />}
        {content === 'features' && <Features />}
        {content === 'feature-matrix' && <FeatureMatrix />}
        {content === 'technical-details' && <TechnicalDetails />}
      </div>
    </div>
  );
}
